import React from 'react';
import Radium from 'radium';
import { WithLoading } from '@widergy/energy-ui';

import UTForm from 'app/components/UTForm';
import { emailField, passwordField, captchaField } from 'constants/fields';
import { appConfig } from 'config/customization';

import styles from './styles';

const fields = appConfig.signUp.personalInformationFields.captcha.show
  ? [emailField, passwordField, captchaField]
  : [emailField, passwordField];

const UserRegister = () => <UTForm fields={fields} fieldClasses={{ container: styles.field }} />;

export default WithLoading(props => props.loading)(Radium(UserRegister));
